import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  SUPPORTED_LANGS = ['pt', 'en', 'de', 'es', 'fr'];
  DEFAULT_LANG = 'pt';

  constructor(private translateService: TranslateService) { 
  }

  public init(): Promise<void> {
    return this.initLanguage();
  }

  private async initLanguage() {
    const browserLang = this.translateService.getBrowserLang();

    this.translateService.addLangs(this.SUPPORTED_LANGS);
    this.translateService.setDefaultLang(this.DEFAULT_LANG);


    const selectedLang = this.SUPPORTED_LANGS.includes(browserLang!) ? browserLang! : this.DEFAULT_LANG;
    await firstValueFrom(this.translateService.use(selectedLang));
  }
}
